import { useEffect, useState } from "react";
import Api from "../openapi";
import { AdminSubscriptionDetailResponse } from "../openapi/client";
import { checkIf } from "../utils";

export default function useUserSubscriptions(userId?: string, refresh?: number) {
  const [userSubscriptions, setUserSubscriptions] = useState<AdminSubscriptionDetailResponse[]>([]);

  useEffect(() => {
    const getUserSubscriptions = async () => {
      try {
        const res = await Api.Subscription.listSubscriptions(String(userId));
        setUserSubscriptions(res.data);
      } catch (error) {}
    };
    if (checkIf(userId)) {
      getUserSubscriptions();
    }
  }, [userId, refresh]);
  return userSubscriptions;
}
